import { render, staticRenderFns } from "./find-password.vue?vue&type=template&id=b0819462&"
import script from "./find-password.vue?vue&type=script&lang=js&"
export * from "./find-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports